module.exports = __webpack_public_path__ + "img/place.f61534d3.png";